import Alert from 'react-s-alert';
import { DSOS_ACTIONS, SHOW_MESSAGE } from '../actions/actionTypes';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';

const BLOCKED_ERRORS = [DSOS_ACTIONS.REMOVE_REGION_FROM_DSO_FAILURE];

export default (state = { message: null }, action) => {
  const { type } = action;

  if (BLOCKED_ERRORS.includes(type)) {
    return state;
  }

  const matches = /(.*)_(FAILURE)/.exec(type);
  if (matches) {
    const authServiceErrors = [action.payload?.response?.data?.error].filter(Boolean);
    const errors = action.payload.response?.data?.errors || authServiceErrors;
    const message = errors.map((err) => err.message || err).join('\n');
    Alert.error(message, {
      position: 'bottom-right',
      effect: 'slide',
      beep: false,
      timeout: 5000,
      offset: 100,
    });
    return state;
  }

  switch (action.type) {
    case SHOW_MESSAGE:
      const { message } = action.payload;
      Alert.success(message, {
        position: 'bottom-right',
        effect: 'slide',
        beep: false,
        timeout: 5000,
        offset: 100,
      });
      break;
    default:
      break;
  }

  return state;
};
